/* unplugin-vue-components disabled */import script from "./publish.vue?vue&type=script&setup=true&lang=js"
export * from "./publish.vue?vue&type=script&setup=true&lang=js"

import "./publish.vue?vue&type=style&index=0&id=0da57ca8&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da57ca8"]])

export default __exports__